import type { ReactNode, ComponentProps } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { ToggleGroup } from '@shared/components/ui/toggle-group';

type Props = Omit<ComponentProps<typeof ToggleGroup>, 'type' | 'value' | 'onValueChange' | 'defaultValue'> & {
  name: string;
  /** `ToggleGroupItem` */
  children: ReactNode;
};

/** Choix exclusif (un seul élément sélectionné, jamais vide) piloté par react-hook-form. */
export const RHFToggleGroup = ({ name, children, ...other }: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <>
          <ToggleGroup
            {...other}
            // Une valeur vide = l'élément sélectionné a été recliqué : on garde la valeur courante.
            onValueChange={(value) => value && field.onChange(value)}
            type="single"
            value={field.value ?? ''}
          >
            {children}
          </ToggleGroup>
          {error?.message && <p className="mt-1 text-xs text-destructive">{error.message}</p>}
        </>
      )}
    />
  );
};
